import Icon from 'veui/components/Icon'
import { IconCalendar } from 'dls-icons-vue'

Icon.register('calendar', IconCalendar)
